import {
  TEntityResponse,
  TEntityListResponse,
  TCreateResourceReqBody,
  TResourceResBody,
  TResourceSummaryResBody,
  TUpdateResourceReqBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TResourcesClient = {
  create(body: TCreateResourceReqBody): Promise<TEntityResponse<'resource', TResourceResBody> | undefined>;
  update(id: string, body: TUpdateResourceReqBody): Promise<TEntityResponse<'resource', TResourceResBody> | undefined>;
  delete(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'resource', TResourceResBody> | undefined>;
  list(limit: number, page: number): Promise<TEntityListResponse<'resource', TResourceSummaryResBody> | undefined>;
};

function ResourcesClient(apiClient: TAPIClient): TResourcesClient {
  return {
    async create(body: TCreateResourceReqBody): Promise<TEntityResponse<'resource', TResourceResBody> | undefined> {
      const data = await apiClient.post<TCreateResourceReqBody, TEntityResponse<'resource', TResourceResBody>>(
        '/resources',
        body
      );

      if (data && data.type !== 'resource') {
        throw new Error('Invalid entity type received, expected: resource, received: ' + data.type);
      }

      return data;
    },

    async update(
      id: string,
      body: TUpdateResourceReqBody
    ): Promise<TEntityResponse<'resource', TResourceResBody> | undefined> {
      const data = await apiClient.put<TUpdateResourceReqBody, TEntityResponse<'resource', TResourceResBody>>(
        `/resources/${id}`,
        body
      );

      if (data && data.type !== 'resource') {
        throw new Error('Invalid entity type received, expected: resource, received: ' + data.type);
      }

      return data;
    },

    async delete(id: string): Promise<void> {
      return await apiClient.delete(`/resources/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'resource', TResourceResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'resource', TResourceResBody>>(`/resources/${id}`);

      if (data && data.type !== 'resource') {
        throw new Error('Invalid entity type received, expected: resource, received: ' + data.type);
      }

      return data;
    },

    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'resource', TResourceSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'resource', TResourceSummaryResBody>>(
        `/resources?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'resource') {
        throw new Error('Invalid entity type received, expected: resource, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TResourcesClient, ResourcesClient };
